import {
  CustomerCharacteristicType,
  SegmentConditionCategory,
} from "@redotech/redo-customer-segments-common/marketing/segments/segment-types";
import AnnouncementIcon from "@redotech/redo-icons/announcement-02.svg";
import CoinsStackedIcon from "@redotech/redo-icons/coins-stacked-03.svg";
import FlipBackwardIcon from "@redotech/redo-icons/flip-backward_filled.svg";
import MarkerPinIcon from "@redotech/redo-icons/marker-pin-01.svg";
import PhoneIcon from "@redotech/redo-icons/phone.svg";
import ShoppingBagIcon from "@redotech/redo-icons/shopping-bag-02.svg";
import UserIcon from "@redotech/redo-icons/user-02.svg";
import LoyaltyLionIcon from "@redotech/redo-web/integration-logos/loyalty-lion.svg";
import { JSXElementConstructor } from "react";

export const segmentCategoryToIcon: Record<
  SegmentConditionCategory,
  JSXElementConstructor<any>
> = {
  [SegmentConditionCategory.ACCOUNT]: UserIcon,
  [SegmentConditionCategory.MARKETING]: AnnouncementIcon,
  [SegmentConditionCategory.SHOPPING]: ShoppingBagIcon,
  [SegmentConditionCategory.LOYALTY_LION]: LoyaltyLionIcon,
};

export const segmentCategoryToFriendly: Record<
  SegmentConditionCategory,
  string
> = {
  [SegmentConditionCategory.ACCOUNT]: "Account",
  [SegmentConditionCategory.MARKETING]: "Marketing",
  [SegmentConditionCategory.SHOPPING]: "Shopping",
  [SegmentConditionCategory.LOYALTY_LION]: "LoyaltyLion",
};

export const characteristicToIcon: Record<
  CustomerCharacteristicType,
  JSXElementConstructor<any> | undefined
> = {
  [CustomerCharacteristicType.LIFETIME_REVENUE]: CoinsStackedIcon,
  [CustomerCharacteristicType.RETURN_RATE_COUNT]: FlipBackwardIcon,
  [CustomerCharacteristicType.RETURN_RATE_VALUE]: FlipBackwardIcon,
  [CustomerCharacteristicType.SUBSCRIBED_TO_EMAIL]: undefined,
  [CustomerCharacteristicType.CAN_RECEIVE_EMAIL_MARKETING]: undefined,
  [CustomerCharacteristicType.STATIC_SEGMENT_MEMBERSHIP]: undefined,
  [CustomerCharacteristicType.CREATED_TIME]: undefined,
  [CustomerCharacteristicType.CUSTOMER_TAGS]: undefined,
  [CustomerCharacteristicType.SUBSCRIBED_TO_SMS]: undefined,
  [CustomerCharacteristicType.COUNTRY]: MarkerPinIcon,
  [CustomerCharacteristicType.STATE_PROVINCE]: MarkerPinIcon,
  [CustomerCharacteristicType.CITY]: MarkerPinIcon,
  [CustomerCharacteristicType.PROXIMITY_TO_CITY]: MarkerPinIcon,
  [CustomerCharacteristicType.CUSTOM_FIELDS]: undefined,
  [CustomerCharacteristicType.BIRTHDAY]: undefined,
  [CustomerCharacteristicType.PHONE_NUMBER_AREA_CODE]: PhoneIcon,
  [CustomerCharacteristicType.ENROLLED_IN_LOYALTY_LION]: undefined,
  [CustomerCharacteristicType.EMAIL_ADDRESS]: undefined,
  [CustomerCharacteristicType.CUSTOMER_NAME]: undefined,
};
